// Deep-link to a candidate's application within a job — opens the job's
// candidate list with that application's drawer on its current-job tab
// (`?tab=candidates&appId=…&appTab=current-job`, the app's canonical
// application URL). The underway row already carries the job id and each
// candidate id IS the application id, so the link is derived at render from
// those. Returns '' when either id is missing, so callers render a plain
// (non-linked) pill instead of a wrong link.
export const getCandidateApplicationUrl = (
  jobId: string | number | undefined,
  applicationId: string | number | undefined
): string =>
  jobId && applicationId
    ? `/jobs/${jobId}?tab=candidates&appId=${applicationId}&appTab=current-job`
    : '';
